import React, { useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { AuthContext } from "../../context/Auth/AuthContext";

import { Button, Divider, } from "@material-ui/core";
import ContactAvatar from "../ContactAvatar";

const VcardPreview = ({ contact, numbers }) => {
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const [selectedContact, setContact] = useState({
        name: "",
        number: 0,
        profilePicUrl: ""
    });
    const [loading, setLoading] = useState(false);

    const contactName = String(contact || "Contato recebido").trim();
    const contactNumber = String(numbers || "").replace(/\D/g, "");

    const handleNewChat = async () => {
        try {
            setLoading(true);
            let contactId = selectedContact.id;

            if (!contactId) {
                const { data } = await api.post("/contact", {
                    name: contactName,
                    number: contactNumber,
                    email: ""
                });
                setContact(data);
                contactId = data.id;
            }

            const { data: ticket } = await api.post("/tickets", {
                contactId,
                userId: user.id,
                status: "open",
            });
            history.push(`/tickets/${ticket.id}`);
        } catch (err) {
            toastError(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div style={{
                minWidth: "250px",
            }}>
                <Grid container spacing={1}>
                    <Grid item xs={2}>
                        <ContactAvatar contact={selectedContact} />
                    </Grid>
                    <Grid item xs={9}>
                        <Typography style={{ marginTop: "12px", marginLeft: "10px" }} variant="subtitle1" color="primary" gutterBottom>
                            {selectedContact.name || contactName}
                        </Typography>
                        {contactNumber && (
                            <Typography style={{ marginLeft: "10px", marginTop: "-6px" }} variant="body2" color="textSecondary">
                                {contactNumber}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleNewChat}
                            disabled={!contactNumber || loading}
                        >{loading ? "Abrindo..." : "Salvar e conversar"}</Button>
                    </Grid>
                </Grid>
            </div>
        </>
    );

};

export default VcardPreview;
